/**
 * The rows the task board's Pinned tile shows, by status (Part 09
 * decision 3): urgency order at rest, without Done; every status while the
 * wall searches.
 */
import type { Task, TaskStatus } from "@/api/tasks";
import { sortTaskBoardOrder } from "./task-order";

const URGENCY_ORDER: readonly TaskStatus[] = [
  "blocked",
  "in_progress",
  "in_review",
  "todo",
  "backlog",
];
const SEARCH_ORDER: readonly TaskStatus[] = [...URGENCY_ORDER, "done"];

export interface TaskboardStatusGroup {
  status: TaskStatus;
  tasks: readonly Task[];
}

/** `tasks` by status, in the tile's order; while searching they are the matching ones. */
export function taskboardStatusGroups(
  tasks: readonly Task[],
  query: string,
): readonly TaskboardStatusGroup[] {
  const ordered = sortTaskBoardOrder([...tasks]);
  return (query ? SEARCH_ORDER : URGENCY_ORDER)
    .map((status) => ({
      status,
      tasks: ordered.filter((task) => task.status === status),
    }))
    .filter((group) => group.tasks.length > 0);
}
